<i18n>
{
  "ru":{
    "response_code": "Код ответа",
    "response_text": "Текст ответа"
  },
  "en":{
    "response_code": "Response code",
    "response_text": "Response text"
  }
}
</i18n>
<template>
  <div style="margin: auto;max-width: 900px;">
    <payment-details-modal
      v-if="showPaymentDetailsModal"
      :visible.sync="showPaymentDetailsModal"
      :url="paymentDetailsUrl"
    />
    <el-row :gutter="20" v-loading="loading">
      <el-col v-if="filter">
        <el-card>
          <h2 class="search--panel-title">{{ $t('search') }}:</h2>
          <el-form
            class="search_filter payment-log"
            :class="(filterCollapsed && emptyFilter ? 'collapsed' : '') + (showRootSearchParams ? ' search-filter-with-root-params' : '')"
            @submit.native.prevent="loadPaymentsLog"
          >
            <input class="hidden-input" ref="hidden" />
            <el-row :gutter="20">
              <!-- <el-col :sm="8" style="position: relative">
                <div class="el-loading-mask"></div>
                <span class="label"></span>
                <el-input ></el-input>
              </el-col>-->
              <el-col :sm="6">
                <a
                  href="#"
                  class="label"
                  @click.prevent="changeSort('batch_date')"
                >
                  {{ $t('batch_date') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'batch_date' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'batch_date' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-date-picker
                  type="date"
                  ref="from"
                  v-model="filter.search_form_date_orig_date_from"
                  @change="$refs['hidden'].focus()"
                  :placeholder="$t('from')"
                ></el-date-picker>
              </el-col>
              <el-col :sm="6">
                <span class="label">&nbsp;</span>
                <el-date-picker
                  type="date"
                  v-model="filter.search_form_date_orig_date_to"
                  @change="$refs['hidden'].focus()"
                  :placeholder="$t('to')"
                ></el-date-picker>
              </el-col>
              <el-col :sm="6">
                <span class="label">RRN</span>
                <el-input v-model="filter.search_form_reserv2"></el-input>
              </el-col>
              <el-col :sm="6">
                <span class="label">E-mail</span>
                <el-input
                  placeholder="E-mail"
                  v-model="filter.search_form_email"
                ></el-input>
              </el-col>
              <el-col :sm="8">
                <a
                  href="#"
                  class="label"
                  @click.prevent="changeSort('field_id2')"
                >
                  {{ $t('transaction_id') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'field_id2' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'field_id2' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-input
                  v-model="filter.search_form_transaction_id"
                ></el-input>
              </el-col>
              <el-col :sm="8">
                <a
                  href="#"
                  class="label"
                  @click.prevent="changeSort('field_id')"
                >
                  ID
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'field_id' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'field_id' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-input v-model="filter.search_form_id"></el-input>
              </el-col>
              <el-col :sm="8">
                <a
                  href="#"
                  class="label"
                  @click.prevent="changeSort('masked_pan')"
                >
                  {{ $t('by_card') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'masked_pan' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'masked_pan' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-row>
                  <el-col :span="8">
                    <el-input
                      v-model="filter.search_form_reserv3[0]"
                      maxlength="6"
                      class="input-no-padding"
                    ></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      disabled
                      placeholder="XX XXXX"
                      class="input-no-padding"
                    ></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      v-model="filter.search_form_reserv3[1]"
                      maxlength="4"
                      class="input-no-padding"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :sm="6" :xs="12">
                <a
                  href="#"
                  class="label"
                  @click.prevent="changeSort('field_payment_method')"
                >
                  {{ $t('payment_method') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'field_payment_method' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'field_payment_method' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
              </el-col>
              <el-col :sm="6" :xs="12">
                <a
                  href="#"
                  class="label"
                  @click.prevent="changeSort('field_response_code1')"
                >
                  {{ $t('response_code') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'field_response_code1' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'field_response_code1' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
              </el-col>
              <el-col :sm="6" :xs="12">
                <a
                  href="#"
                  class="label"
                  @click.prevent="changeSort('field_response_code2')"
                >
                  {{ $t('response_text') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'field_response_code2' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'field_response_code2' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
              </el-col>
              <el-col :sm="6" :xs="12">
                <a
                  href="#"
                  class="label"
                  @click.prevent="changeSort('field_3ds')"
                >
                  3DS
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'field_3ds' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'field_3ds' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
              </el-col>
            </el-row>
            <el-row
                :gutter="20"
                v-if="showRootSearchParams"
            >
              <el-col :sm="6">
                <span class="label">{{ $t('field_terminal_id') }}</span>
                <el-input
                    :placeholder="$t('field_terminal_id')"
                    v-model="filter.search_form_reserv4"
                ></el-input>
              </el-col>
              <el-col :sm="6">
                <span class="label">{{ $t('field_invoice_po') }}</span>
                <el-input
                    :placeholder="$t('field_invoice_po')"
                    v-model="filter.search_form_po_name"
                ></el-input>
              </el-col>
              <el-col :sm="6">
                <span class="label">{{ $t('field_customer_id') }}</span>
                <el-input
                    :placeholder="$t('field_customer_id')"
                    v-model="filter.search_form_customer_id"
                ></el-input>
              </el-col>
              <el-col :sm="6">
                <span class="label">{{ $t('field_phone_number') }}</span>
                <el-input
                    :placeholder="$t('field_phone_number')"
                    v-model="filter.search_form_phone"
                ></el-input>
              </el-col>
            </el-row>
            <el-row
                :gutter="20"
                v-if="showRootSearchParams"
            >
              <el-col :sm="6">
                <span class="label">{{ $t('field_currency_code') }}</span>
                <el-input
                    :placeholder="$t('field_currency_code')"
                    v-model="filter.search_form_currency_code"
                ></el-input>
              </el-col>
              <el-col :sm="6">
                <span class="label">{{ $t('field_card_brand') }}</span>
                <el-input
                    :placeholder="$t('field_card_brand')"
                    v-model="filter.search_form_card_brand"
                ></el-input>
              </el-col>
              <el-col :sm="6">
                <span class="label">{{ $t('field_service_id') }}</span>
                <el-input
                    :placeholder="$t('field_service_id')"
                    v-model="filter.search_form_service_id"
                ></el-input>
              </el-col>
              <el-col :sm="6">
                <span class="label">{{ $t('field_recurring_payment') }}</span>
                <el-select v-model="filter.search_form_recurring_payment" clearable>
                  <el-option
                      v-for="item in recurringPaymentOptions"
                      :value="item.value"
                      v-bind:key="item.key"
                      v-bind:label="$t(item.label)"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="aligner right">
              <span class="label">&thinsp;</span>
              <div>
                <el-button round type="danger" size="small" @click="reset()">{{
                  $t('clear')
                }}</el-button>
                <el-button
                  round
                  type="primary"
                  size="small"
                  native-type="submit"
                  >{{ $t('search') }}</el-button
                >
              </div>
            </el-row>
          </el-form>
          <el-row class="aligner">
            <i
              class="filter-collapse-icon"
              :class="{ open: filterCollapsed && emptyFilter }"
              @click="filterCollapsed = !filterCollapsed"
            ></i>
          </el-row>
        </el-card>
      </el-col>
      <el-col v-if="tableData.length">
        <el-card v-for="paymentLog in tableData" :key="paymentLog.id">
          <div
            class="list-item-header payment-log"
            @click.prevent="paymentLog.show = !paymentLog.show"
          >
            <el-row :gutter="20">
              <el-col :span="5" :xs="12">
                <div class="list-item-text">
                  ID:
                  <span>{{ paymentLog.id }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('transaction_id') }}:
                  <span>
                    <a
                      href="#"
                      @click.prevent.stop="
                        goToTransaction(paymentLog.url_transaction)
                      "
                      >{{ paymentLog.transaction_id }}</a
                    >
                  </span>
                </div>
              </el-col>
              <el-col :span="5" :xs="12">
                <div class="list-item-text">
                  {{ $t('date_orig') }}:
                  <span>{{ paymentLog.date_orig }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('batch_date') }}:
                  <span>{{ paymentLog.transaction_batch_timestamp }}</span>
                </div>
              </el-col>
              <el-col :span="5" :xs="12">
                <div class="list-item-text">
                  {{ $t('payment_method') }}:
                  <span>
                    <span
                      class="card_brand"
                      :class="{
                        visa: paymentLog.item_type == 'VISA',
                        mastercard:
                          paymentLog.item_type == 'MASTERCARD' ||
                          paymentLog.item_type == 'MC',
                        belcard: paymentLog.item_type == 'БЕЛКАРТ',
                        belqi: paymentLog.item_type == 'BELQI WALLET'
                      }"
                    ></span>
                    <span>{{ paymentLog.reserv3 }}</span>
                  </span>
                </div>
              </el-col>
              <el-col :span="5" :xs="8">
                <div class="list-item-text">
                  {{ $t('response_code') }}:
                  <span>{{ paymentLog.response_code1 }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('response_text') }}:
                  <span>{{ paymentLog.response_code2 }}</span>
                </div>
              </el-col>
              <el-col :span="4" :xs="8">
                <div class="list-item-text">
                  {{ $t('account_id') }}:
                  <span>{{ paymentLog.transaction_account_id }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('status_3ds') }}:
                  <span>{{
                    $t(
                      paymentLog.transaction_log_tds_using == '1' ? 'yes' : 'no'
                    )
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </div>

          <payment-log-details
            v-if="paymentLog.url_transaction_log && paymentLog.show"
            :visible.sync="paymentLog.show"
            :url="paymentLog.url_transaction_log"
          />
        </el-card>
      </el-col>
      <el-col v-if="tableData.length" :offset="0" :span="24">
        <el-card>
          <el-pagination
            class="aligner right"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
            @current-change="changePage"
          ></el-pagination>
        </el-card>
      </el-col>
      <el-col :span="24" v-if="!loading && !tableData.length">
        <el-card class="aligner">{{ $t('notfound') }}</el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
import { eventBus } from '../../event-bus'
import Group from '../common/Group'
import PaymentDetailsModal from '../payments/PaymentDetailsModal'
import PaymentLogDetails from './PaymentsLogDetails'
import TokenParser from '../helper/TokenParser'

export default {
  name: 'payments-log',
  components: {
    'payment-details-modal': PaymentDetailsModal,
    'payment-log-details': PaymentLogDetails
  },
  data: () => ({
    filter: null,
    pagination: null,
    userData: null,

    pageLinks: {},
    sortLinks: {},

    tableData: [],
    loading: true,
    filterCollapsed: true,

    paymentDetailsUrl: '',
    showPaymentDetailsModal: false,
    recurringPaymentOptions: [{ key: 0, value: 0, label: 'no' }, { key: 1, value: 1, label: 'yes' }]
  }),
  created () {
    this.reset()
    eventBus.$on('reload', this.reloadRoute)
  },
  beforeDestroy () {
    eventBus.$off('reload', this.reloadRoute)
  },
  methods: {
    reloadRoute (route) {
      if (route === this.$router.currentRoute.name) {
        this.reset()
      }
    },
    goToTransaction (url) {
      if (url) {
        this.paymentDetailsUrl = url
        this.showPaymentDetailsModal = true
      }
    },
    reset () {
      this.initData()
      this.loadPaymentsLog()
    },
    initData () {
      this.filter = {
        search_form_distinct_id: '',
        search_form_date_orig_date_from: '',
        search_form_date_orig_date_to: '',
        search_form_reserv3: ['', ''],
        search_form_reserv2: '',
        search_field_type_reserv2: 'direct_like',
        search_form_psid: '',
        search_field_type_psid: 'direct_like',
        search_form_processing: '',
        search_field_type_processing: 'direct_like',
        search_form_item_name: '',
        search_form_email: '',
        search_field_type_email: 'left_like',
        search_form_client_ip: '',
        search_form_id: '',
        search_field_type_id: 'direct',
        search_form_transaction_id: '',
        search_field_type_transaction_id: 'direct',
        search_form_misc: '',
        search_form_afa_using: '',
        search_field_type_afa_using: 'direct_like',
        search_form_payment_method: '',
        search_field_type_payment_method: 'direct',
        search_form_reserv4: '',
        search_form_po_name: '',
        search_form_customer_id: '',
        search_form_phone: '',
        search_form_currency_code: '',
        search_form_card_brand: '',
        search_form_service_id: '',
        search_form_recurring_payment: '',
        submit: 'Поиск',

        order_type: '',
        order_field: ''
      }

      const jwtToken = window.localStorage.getItem('jwt_token')
      this.userData = jwtToken === null ? null : TokenParser.parse(jwtToken)

      this.pagination = {
        total: 0,
        pageSize: 25,
        currentPage: 0
      }
    },
    parsePaymentsLog (promise) {
      this.loading = true
      this.tableData = []
      promise
        .then(data => {
          if (data.page_vars) {
            let vars = data.page_vars
            vars.res.records.forEach(r => {
              if (!r.transaction_id || r.transaction_id === '0') {
                r.transaction_id = '-'
              }
              if (!r.transaction_account_id || r.transaction_account_id === '0') {
                r.transaction_account_id = '-'
              }
              r.transaction_batch_timestamp = r.transaction_batch_timestamp
                ? new Date(
                  parseInt(r.transaction_batch_timestamp) * 1000
                ).toLocaleString(this.$locale)
                : '-'
              r.request_time = r.request_time
                ? new Date(parseInt(r.request_time) * 1000).toLocaleString(
                  this.$locale
                )
                : '-'

              if (r.date_orig) {
                r.date_orig = new Date(
                  parseInt(r.date_orig) * 1000
                ).toLocaleString(this.$locale)
              }
              if (r.item_type) {
                r.item_type = r.item_type.toUpperCase()
              }

              r.show = false
            })
            this.tableData = vars.res.records
            this.pagination = {
              total: parseInt(vars.res.results),
              currentPage: parseInt(vars.res.cpage),
              pageSize: parseInt(vars.res.limit)
            }

            if (!this.pageLinks) this.pageLinks = {}
            if (vars.paginator) {
              if (vars.paginator.end_pages) {
                Object.keys(vars.paginator.end_pages).forEach(k => {
                  this.pageLinks[k] = vars.paginator.end_pages[k]
                })
              }
              if (vars.paginator.pre_pages) {
                Object.keys(vars.paginator.pre_pages).forEach(k => {
                  this.pageLinks[k] = vars.paginator.pre_pages[k]
                })
              }
              if (vars.paginator.next_pages) {
                Object.keys(vars.paginator.next_pages).forEach(k => {
                  this.pageLinks[k] = vars.paginator.next_pages[k]
                })
              }
            }

            this.filter.order_field = vars.res.order
            this.filter.order_type = vars.res.sort
            this.sortLinks = vars.transaction_data
          } else {
            this.tableData = []
            this.pagination = {}
          }

          this.loading = false
        })
        .catch(() => {
          this.$notify.error({
            title: this.$t('error'),
            message: ''
          })
          this.loading = false
        })
    },
    loadPaymentsLog () {
      this.parsePaymentsLog(apiRes.post(apiRes.paymentsLogUrl, this.filter))
    },
    changePage (newPage) {
      if (this.pageLinks[newPage]) {
        this.parsePaymentsLog(apiRes.get(this.pageLinks[newPage]))
      }
    },
    changeSort (name) {
      // if (this.filter.order_field === name) {
      //   this.filter.order_type = this.filter.order_type === 'asc' ? 'desc' : 'asc'
      // } else {
      //   this.filter.order_field = name
      //   this.filter.order_type = 'asc'
      // }

      // this.loadPaymentsLog()
      if (this.sortLinks[name]) {
        this.parsePaymentsLog(apiRes.get(this.sortLinks[name]))
      }
    }
  },
  computed: {
    showRootSearchParams () {
      if (this.userData === null || !this.userData.hasOwnProperty('group')) {
        return false
      }

      return this.userData.group === Group.ROOT
    },
    emptyFilter () {
      return (
        !this.filter ||
        (!this.filter.search_form_date_orig_date_from &&
          !this.filter.search_form_date_orig_date_to &&
          !this.filter.search_form_reserv2 &&
          !this.filter.search_form_email &&
          !this.filter.search_form_transaction_id &&
          !this.filter.search_form_id &&
          !this.filter.search_form_reserv3[0] &&
          !this.filter.search_form_reserv3[1] &&
          !this.filter.search_form_reserv4 &&
          !this.filter.search_form_po_name &&
          !this.filter.search_form_customer_id &&
          !this.filter.search_form_phone &&
          !this.filter.search_form_currency_code &&
          !this.filter.search_form_card_brand &&
          !this.filter.search_form_service_id &&
          !this.filter.search_form_recurring_payment)
      )
    }
  }
}
</script>

<style>
.search_filter.payment-log:not(.collapsed) {
  height: 235px;
}

.search_filter.payment-log.search-filter-with-root-params:not(.collapsed) {
  height: 435px;
}

.list-item-header.payment-log .card_brand {
  height: 42px;
  width: 80px;
}

.list-item-header.payment-log .card_brand + span {
  display: inline-block;
  margin-left: 5px;
  width: 100%;
}

.item_payment_amount {
  color: #c1c1c1;
  font-size: 10px;
}

@media only screen and (max-width: 420px),
  (min-width: 420px) and (max-width: 767px) {
  .search_filter.payment-log:not(.collapsed) {
    height: 620px;
  }
  .search_filter.payment-log.search-filter-with-root-params:not(.collapsed) {
    height: 1340px;
  }
}
</style>
